import { createOptions } from 'options';
import { paymentStates, invoiceTypes, invoiceStates } from './types';

export const paymentStateOptions = createOptions(paymentStates);
export const invoiceTypeOptions = createOptions(invoiceTypes);
export const invoiceStateOptions = createOptions(invoiceStates);
